import { render, staticRenderFns } from "./PropertyStore.vue?vue&type=template&id=705ba2b2&scoped=true"
import script from "./PropertyStore.vue?vue&type=script&lang=js"
export * from "./PropertyStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705ba2b2",
  null
  
)

export default component.exports